import { computed, defineComponent, reactive, ref, watch } from "vue";
import ColorPicker from "@com/components/color-picker/index.vue";
import { normalizeHsv, normalizeHsvToCocosFormat, normalizeRgba, normalizeToCocosFormat } from "@/views/creative/utils/cocos-color-exchange";
import tinycolor from "tinycolor2";
export default defineComponent({
    components: {
        ColorPicker: ColorPicker
    },
    props: {
        format: String,
        color: Array
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var disabledAlpha = computed(function() {
            if (props.format === "rgba") {
                return false;
            }
            return true;
        });
        var model = reactive({
            color: ""
        });
        var currentColor = ref("");
        var noColorMode = ref(false);
        var handleColorChange = function(val) {
            console.log("handleColorChange", val);
            var color;
            if (props.format === "hsv") {
                color = normalizeHsvToCocosFormat([
                    val.hsv.h,
                    val.hsv.s,
                    val.hsv.v
                ]);
            } else if (props.format === "rgba") {
                color = normalizeToCocosFormat([
                    val.rgba.r,
                    val.rgba.g,
                    val.rgba.b,
                    val.rgba.a, 
                ]);
            }
            emit("changeColor", color);
        };
        watch(function() {
            return props.color;
        }, function(val) {
            if (val) {
                if (props.format === "hsv") {
                    if (props.color[0] === 1) {
                        noColorMode.value = true;
                    } else {
                        noColorMode.value = false;
                    }
                    var normalHSV = normalizeHsv(val);
                    var color = tinycolor({
                        h: normalHSV[0],
                        s: normalHSV[1],
                        v: normalHSV[2]
                    });
                    currentColor.value = color.toRgbString();
                    model.color = color.toRgbString();
                } else if (props.format === "rgba") {
                    var normalRGBA = normalizeRgba(val);
                    var color1 = tinycolor({
                        r: normalRGBA[0],
                        g: normalRGBA[1],
                        b: normalRGBA[2],
                        a: normalRGBA[3]
                    });
                    currentColor.value = color1.toRgbString();
                    model.color = color1.toRgbString();
                }
            }
        }, {
            immediate: true
        });
        return {
            handleColorChange: handleColorChange,
            disabledAlpha: disabledAlpha,
            currentColor: currentColor,
            model: model,
            noColorMode: noColorMode
        };
    }
});
